// @flow
import React from 'react'
import { Field, reduxForm } from 'redux-form'
import styles from './styles.css'
import { renderSelectField, renderInputField, renderTextAreaField } from 'components/FormFields'
import { STATUS_OPTIONS } from 'lib/constants'
import { Button } from 'components/Button'

type Props = {
  handleSubmit: Function,
  submitting: boolean,
  pristine: boolean,
  reset: Function,
  dispatch: Function,
  onCancel: Function,
  initialValues: Object,
  subaccount: Object,
  accountNumber: string,
  subnumber: string,
  onSuccess: Function,
}

const MsaForm = (props: Props) => {
  const { handleSubmit, submitting, pristine, onCancel } = props

  return (
    <form onSubmit={handleSubmit}>
      <div className={styles.contentContainer}>
        <div className={styles.formRow}>
          <div className={styles.formSection}>
            <section data-active={true} className={styles.collapseRef}>
              <div className={styles.titleSection}>
                <div className={styles.title}>
                  <h5>MSA details</h5>
                </div>
              </div>
              <div className={styles.docsWrapper}>
                <Field
                  name="contact_info"
                  type="text"
                  component={renderTextAreaField}
                  label="Contact Information"
                  placeholder="Enter name, email, and phone"
                  cleaner={(val) => val && val.trim()}
                />
              </div>
              <div className={styles.docsWrapper}>
                <Field
                  name="statement_info"
                  type="text"
                  component={renderInputField}
                  label="Statement Delivery"
                  placeholder="ex: emailed, monthly"
                />
              </div>
            </section>
          </div>

          <div className={styles.formSection}>
            <section data-active={true} className={styles.collapseRef}>
              <div className={styles.titleSection}>
                <div className={styles.title}>
                  <h5>Status Information</h5>
                </div>
              </div>
              <div className={styles.docsWrapper}>
                <Field name="status" component={renderSelectField} label="Current Status" options={STATUS_OPTIONS} placeholder="Active" />
              </div>
            </section>
          </div>
        </div>
      </div>
      <div className={styles.row}>
        <Button size="default" color="red" label="Cancel" onClick={onCancel} type="button" disabled={submitting} />
        <Button size="default" color="blue" label="Save Changes" type="submit" disabled={pristine || submitting} />
      </div>
    </form>
  )
}

export default reduxForm({
  form: 'msaSubaccountForm',
  enableReinitialize: true,
})(MsaForm)
